import { menuActions } from "../_constants/actionConstants";
import { mainMenuDefaultOptions } from "../_mainMenu/mainMenuOptions";
import { menuTypes } from "../_constants/menuTypes";
import { DOCTYPE } from "../_constants/docTypeConstants";

/**
 * MainMenuState - Redux state for main menu
 * @typedef {Object} MainMenuState
 * @property {import("../_mainMenu/mainMenuOptions").MenuOption[]} options
 * @property {boolean} fetching
 * @property {Object} [error]
 */

/** @type {MainMenuState} */
const mainMenuInitialState = {
  options: flattenMenuOptions(mainMenuDefaultOptions),
  fetching: false,
  error: null
};

export const reducer = (state = mainMenuInitialState, action) => {
  switch (action.type) {
    case menuActions.BUILD_MENU:
      return { ...state, fetching: true };
    case menuActions.BUILD_MENU_SUCCESS:
      // Payload is the completed user-specific MenuOption[]
      return {
        ...state,
        fetching: false,
        options: flattenMenuOptions({
          ...mainMenuDefaultOptions,
          userSpecific: action.payload
        })
      };
    case menuActions.RESET_MENU_ON_LOGOUT:
      return { ...state, options: flattenMenuOptions(mainMenuDefaultOptions) };
    default:
      return state;
  }
};

/**
 * Flattens both "main" and "userSpecific" menu options from
 * MainMenuDefaultOptions into a single MenuOption[].
 *
 * @param {import("../_mainMenu/mainMenuOptions").MainMenuDefaultOptions} builtMenu
 * @returns {import("../_mainMenu/mainMenuOptions").MenuOption[]}
 */
function flattenMenuOptions(builtMenu) {
  /** @type {import("../_mainMenu/mainMenuOptions").MenuOption[]} */
  let options = [];

  builtMenu.main.forEach(o => options.push(o));
  if (builtMenu.userSpecific && builtMenu.userSpecific.length > 0) {
    // Add separator
    options.push({
      menuId: "m_" + (options.length + 1),
      type: menuTypes.MENU_SEPARATOR,
      label: "",
      link: "",
      docType: DOCTYPE.LINK,
      actions: []
    });
    builtMenu.userSpecific.forEach(o => options.push(o));
  }
  return options;
}
